<div class="row flex-layout title-left-side fx-layout-row fx-align-start">
  <div class="col-sm-12 col-xl-2 col-lg-4">
    <p class="portal-top-text pr-2">View all persons</p>
  </div>
  <div class="col-sm-12 col-xl-2 col-lg-4">
    @if(showReinviteButton && isPartnerGatewayAdmin) {
      <button class="mt-4 fit-content cancel-button" mat-raised-button color="primary"
        [disabled]="isResendInvitationsInProgress" matTooltip="Resend invites for the whole company"
        matTooltipPosition="after" matTooltipClass="quartz-tooltip" (click)="onClickResendInvitations()">
        Resend invitations
      </button>
    }
  </div>
  <div class="col-sm-12 col-xl-4 col-lg-4">
    @if(totalInvites > 0){
      <p class="portal-top-text pr-2">Sending {{ sentInvites }} of {{ totalInvites }}...</p>
    }
  </div>
</div>

<div class="table-and-butons">
  @if(companyId && !companyHasRestrictedAccess && !isViewOnly){
    <div class="title-right-side mt-3 mr-2">
      <a
        [routerLink]="['invite']"
        class="btn-portal-add mr-4"
        matTooltip="Invite person"
        matTooltipPosition="before"
        matTooltipClass="quartz-tooltip">
        <img class="mb-2" src="assets/images/JMicons/JM-icon-15.png" alt="add">
      </a>
      <a
        (click)="openCompanyLinkingDialog()"
        class="btn-portal-add mr-4"
        matTooltip="Link person to company"
        matTooltipPosition="before"
        matTooltipClass="quartz-tooltip">
        <i class="fas fa-link"></i>
      </a>
    </div>
  }
  <div class="portal-example-pager__content">
    <div class="example-container list-container">
      <zing-grid
        [data]="data"
        [tableSettings]="columnSettings"
        [masterSettings]="masterSettings"
        [totalCount]="totalCount"
        [dataKey]="'id'"
        [isLoading]="isLoading"
        [additionalFilter]="defaultFilter"
        (oDataQueryChanged)="loadData($event)">

        <ng-template zingCustomColumn columnName="approvalStatus" let-person>
          {{ approvalStatus[person.approvalStatus] | approvalstatus }}
        </ng-template>

        <ng-template zingCustomColumn columnName="betaExperience" let-person>
          @if(experienceFlagsMap.get(person.referenceId); as flag) {
            <span [title]="flag.effectiveValue
                ? ('Opted in' + (flag.lastModified ? ' on ' + (flag.lastModified | date:'medium') : ''))
                : (flag.optedOut
                    ? ('Opted out' + (flag.lastModified ? ' on ' + (flag.lastModified | date:'medium') : ''))
                    : 'No preference (Classic Zing)')">
              {{ flag.effectiveValue ? 'Yes' : 'No' }}
            </span>
          } @else {
            —
          }
        </ng-template>

        <ng-template #action let-person>
          <div class="text-right">
            @if(person? isPersonReinvitable(person) : false){
              <mat-icon
                (click)="resendInvite(person.email)"
                class="cursor-pointer"
                matTooltip="Resend Invite"
                matTooltipPosition="before"
              matTooltipClass="quartz-tooltip">send</mat-icon>
            }
            @if(isPersonInPendingInviteState(person)){
              <mat-icon
                (click)="sendInviteToPendingUser(person)"
                class="cursor-pointer"
                matTooltip="Resend Invite"
                matTooltipPosition="before"
              matTooltipClass="quartz-tooltip">send</mat-icon>
            }
            <mat-icon
              [routerLink]="['/persons/details', person.id]"
              class="cursor-pointer"
              matTooltip="Edit person details"
              matTooltipPosition="before"
            matTooltipClass="quartz-tooltip">edit</mat-icon>
            @if((isSuperOrPlatformAdmin || isMembershipAdmin) && !isGuestPerson(person)){
              <mat-icon
                (click)="openDeleteDialog(person.id)"
                class="cursor-pointer"
                matTooltip="Delete person"
                matTooltipPosition="before"
              matTooltipClass="quartz-tooltip">delete</mat-icon>
            }
            @if(person.companyId){
              @if (person.companyId) {
                <mat-icon
                  [routerLink]="['/companies/detail', person.companyId]"
                  class="cursor-pointer"
                  matTooltip="View Person company"
                  matTooltipPosition="before"
                matTooltipClass="quartz-tooltip">work</mat-icon>
              }
              }@else{
              <mat-icon
                class="cursor-pointer"
                matTooltip="No registered company"
                matTooltipPosition="before"
              matTooltipClass="quartz-tooltip">work_off</mat-icon>
            }
            <mat-icon
              (click)="openPersonInfoDialog(person)"
              class="cursor-pointer"
              matTooltip="View person info"
              matTooltipPosition="before"
            matTooltipClass="quartz-tooltip">search</mat-icon>
          </div>
        </ng-template>
      </zing-grid>
      <app-simple-pagination [hasMore]="hasMore" (pageChangedEvent)="onPageChange($event)"></app-simple-pagination>
    </div>
  </div>
</div>
